export default{OPEN:"open",Rr:"purchase",zr:"push_click",be:"custom_event",Ar:"iam_click",ks:"test"};